import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ title, onClick, ...rest }) => {
  const { className } = rest;

  const clickHandler = (event) => {
    event.preventDefault();
    onClick();
  };

  return (
    <button
      type="button"
      className={`btn ${className || ''}`}
      onClick={clickHandler}
    >
      {title}
    </button>
  );
};

Button.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Button;
